import React, {Component, ReactNode} from 'react'
import {PAYMENT_TYPE} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import {formatNumberWithCommas} from '../../../formatters/formatNumberWithCommas'
import {
    PaymentInformation,
    PaymentItem,
    ReserveFacilityModel,
    ReserveFacilityModelPaymentObserver,
} from '../ReserveFacilityModel'
import {DisplayItemLabelDiv} from '../../../styledComponents/DisplayItem'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {PaymentItemForViewFacility} from '../element/PaymentItemForViewFacility'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {comparePaymentItem} from '../helpers/compareHelper'

interface Props {
    reservationModel: ReserveFacilityModel
}

interface State {
    items: PaymentItem[]
    totalCharge: Nullable<number>
}

class RRFFReservePaymentView extends Component<Props, State>
    implements ReserveFacilityModelPaymentObserver {
    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            items: [],
            totalCharge: null,
        }
    }

    componentDidMount(): void {
        this.props.reservationModel.addPaymentInformationObserver(this)
    }

    render(): ReactNode {
        const paymentItems: PaymentItem[] =
            (this.state.items.length === 0)
                ? [new PaymentItemForViewFacility(PAYMENT_TYPE.ADMIN_TRANSFER_ACCOUNT, null).toObject()]
                : this.state.items

        return (<>
            <DisplayItemLabelDiv>お支払い金額</DisplayItemLabelDiv>
            <BlockSpacer height={'10px'}/>
            {
                paymentItems
                    .sort((a, b) => comparePaymentItem(a, b))
                    .map((item, index) => {
                        return (<DisplayItemCostInformationContainer key={index}>
                            <DisplayItemCostInformationData>
                                {item.article}：{item.quantityWithUnit}
                            </DisplayItemCostInformationData>
                            <DisplayItemCostPaymentTypeAndSubtotalContainer>
                                <DisplayItemPaymentType>{item.paymentType.label}</DisplayItemPaymentType>
                                <DisplayItemSubtotalCost>{getDisplayCharge(item.charge)}円</DisplayItemSubtotalCost>
                            </DisplayItemCostPaymentTypeAndSubtotalContainer>
                        </DisplayItemCostInformationContainer>)
                    })
            }
            <BlockSpacer height={'20px'}/>
            <DisplayItemTotalCostContainer>
                <DisplayItemTotalCostHeader>合計</DisplayItemTotalCostHeader>
                <DisplayItemTotalCostValue>{getDisplayCharge(this.state.totalCharge)}円</DisplayItemTotalCostValue>
            </DisplayItemTotalCostContainer>
        </>)
    }

    onChangePayment(paymentInformation: PaymentInformation): void {
        this.setState({
            items: paymentInformation.items,
            totalCharge: paymentInformation.totalCharge,
        })
    }
}

function getDisplayCharge(value: Nullable<number>): string {
    return value !== null ? formatNumberWithCommas(value) : COMMON_CONSTANTS.INVALID_CALCULATE_RESULT
}

export default RRFFReservePaymentView

export const DisplayItemCostInformationContainer: StyledDiv = styled.div`
  padding: 1.5rem;
  background-color: ${Colors.LightBlueBackground};
  margin-bottom: 0.2rem;
  border-left: solid 2px ${Colors.LightBorder};
`


export const DisplayItemTotalCostContainer = styled(RowFlexContainer)`
  align-items: flex-end;
`


export const DisplayItemTotalCostHeader: StyledDiv = styled.div`
  margin-left: 1.5rem;
  line-height: 1;
  font-weight: ${FontWeights.Bold};
`

export const DisplayItemTotalCostValue: StyledDiv = styled.div`
  line-height: 1;
  font-size: 2.4rem;
  font-weight: ${FontWeights.Bold};
  margin-right: 1.5rem;
`

export const DisplayItemPaymentType: StyledDiv = styled.div`
  font-size: ${FontSize.Small};
`
export const DisplayItemSubtotalCost: StyledDiv = styled.div`
  width: 10rem;
  text-align: right;
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Bold};
`

export const DisplayItemCostPaymentTypeAndSubtotalContainer = styled(RowFlexContainer)`
  justify-content: flex-end;
  line-height: 1;
`

export const DisplayItemCostInformationData: StyledDiv = styled.div`
  margin-bottom: 1rem;
  font-weight: ${FontWeights.Bold};
  line-height: 1;
`
